export default "__VITE_ASSET__rImn4wBr__"